import React, { useState } from 'react';
import './InteractiveChecklist.css';

const InteractiveChecklist = ({ title, items, progressBar = false, downloadable = false }) => {
  const [checkedItems, setCheckedItems] = useState({});

  const handleCheck = (itemId) => {
    setCheckedItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const completedCount = Object.values(checkedItems).filter(Boolean).length;
  const totalCount = items.length;
  const progressPercentage = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <div className="checklist-container">
      {title && <h3 className="checklist-title">{title}</h3>}
      
      {progressBar && (
        <div className="interactive-progress-bar">
          <div className="interactive-progress-fill" style={{ width: `${progressPercentage}%` }}></div>
          <span className="interactive-progress-text">{completedCount}/{totalCount}</span>
        </div>
      )}

      <div className="checklist-items">
        {items.map((item) => (
          <div key={item.id} className="checklist-item">
            <label className="checklist-label">
              <input
                type="checkbox"
                checked={checkedItems[item.id] || false}
                onChange={() => handleCheck(item.id)}
                className="checklist-checkbox"
              />
              <span className="checklist-text">
                {item.text}
                {item.required && <span className="required-badge">Required</span>}
              </span>
            </label>
            {item.tip && <div className="checklist-tip">{item.tip}</div>}
          </div>
        ))}
      </div>

      {downloadable && (
        <button className="download-btn">
          Download Checklist
        </button>
      )}
    </div>
  );
};

export default InteractiveChecklist;
